import {
  FrontSide, BackSide, DoubleSide,
  NearestFilter,
  NearestMipMapNearestFilter,
  NearestMipMapLinearFilter,
  LinearFilter,
  LinearMipMapNearestFilter,
  LinearMipMapLinearFilter,
  RepeatWrapping,
  ClampToEdgeWrapping,
  MirroredRepeatWrapping,
  UVMapping,
  CubeReflectionMapping,
  CubeRefractionMapping,
  EquirectangularReflectionMapping,
  EquirectangularRefractionMapping,
  SphericalReflectionMapping,
  AlphaFormat,
  RGBFormat,
  RGBAFormat,
  LuminanceFormat,
  LuminanceAlphaFormat,
  UnsignedByteType,
  ByteType,
  ShortType,
  UnsignedShortType,
  IntType,
  UnsignedIntType,
  FloatType,
  HalfFloatType,
  UnsignedShort4444Type,
  UnsignedShort5551Type,
  UnsignedShort565Type } from
"three";


/**
 * Controls which face(s) of a polygon are rendered.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.Side
 */
export const Side = Object.freeze({
  Front: FrontSide,
  Back: BackSide,
  Double: DoubleSide
});

/**
 * Texture minification and magnification filter modes.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.Filter
 */
export const Filter = Object.freeze({
  Nearest: NearestFilter,
  NearestMipMapNearest: NearestMipMapNearestFilter,
  NearestMipMapLinear: NearestMipMapLinearFilter,
  Linear: LinearFilter,
  LinearMipMapNearest: LinearMipMapNearestFilter,
  LinearMipMapLinear: LinearMipMapLinearFilter
});

/**
 * Texture wrapping modes.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.Wrapping
 */
export const Wrapping = Object.freeze({
  Repeat: RepeatWrapping,
  ClampToEdge: ClampToEdgeWrapping,
  MirroredRepeat: MirroredRepeatWrapping
});

/**
 * How a texture is mapped to the surface.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.Mapping
 */
export const Mapping = Object.freeze({
  UV: UVMapping,
  CubeReflection: CubeReflectionMapping,
  CubeRefraction: CubeRefractionMapping,
  EquirectangularReflection: EquirectangularReflectionMapping,
  EquirectangularRefraction: EquirectangularRefractionMapping,
  SphericalReflection: SphericalReflectionMapping
});

/**
 * Texture pixel formats.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.TextureFormat
 */
export const TextureFormat = Object.freeze({
  Alpha: AlphaFormat,
  RGB: RGBFormat,
  RGBA: RGBAFormat,
  Luminance: LuminanceFormat,
  LuminanceAlpha: LuminanceAlphaFormat
});

/**
 * Texture pixel data types.
 * @enum {number}
 * @alias Autodesk.Viewing.Scene.TextureType
 */
export const TextureType = Object.freeze({
  UnsignedByte: UnsignedByteType,
  Byte: ByteType,
  Short: ShortType,
  UnsignedShort: UnsignedShortType,
  Int: IntType,
  UnsignedInt: UnsignedIntType,
  Float: FloatType,
  HalfFloat: HalfFloatType,
  UnsignedShort4444: UnsignedShort4444Type,
  UnsignedShort5551: UnsignedShort5551Type,
  UnsignedShort565: UnsignedShort565Type
});